import HttpClient from '../../../core/HttpClient';
import Failure from '../../../core/Failure';

export class GetE2EMediaPayload {
  constructor(public runKey: string, public runAttempt: number, public mediaId: string) {}
}
async function getE2EMedia(payload: GetE2EMediaPayload): Promise<Blob> {
  try {
    return await HttpClient.getBlob(
      `/backoffice/e2e-results/${encodeURIComponent(payload.runKey)}/attempts/${
        payload.runAttempt
      }/media/${encodeURIComponent(payload.mediaId)}`
    );
  } catch (error) {
    throw new GetE2EMediaFailure(error instanceof Error ? error.message : 'Média indisponible');
  }
}
class GetE2EMediaFailure extends Failure {
  constructor(message: string) {
    super(message, 'e2e-media-failed');
  }
}
export default getE2EMedia;
